<template>
	<v-card flat>
		<v-card-text>
			<h3 class="mb-3 d-sm-none">Диагностика</h3>
			<v-divider class="d-sm-none" />
			<p class="mt-3 mb-1">Причина неисправности:</p>
			<v-textarea
				v-model="breakage_cause"
				outlined
				hide-details
			/>
			<template v-if="showSaveBreakageCauseButton">
				<v-btn
					class="mt-3"
					color="primary"
					outlined
					@click="$emit('set:breakage-cause', breakage_cause)"
				>
					Сохранить
				</v-btn>
				<v-btn
					class="mt-3 ml-2"
					outlined
					@click="setBreakageCauseFromOrder"
				>
					Отмена
				</v-btn>
			</template>
			<p class="mt-3 mb-1">Выявленные неисправности:</p>
			<v-textarea
				v-model="identified_breakages"
				outlined
				hide-details
			/>
			<template v-if="showSaveIdentifiedBreakagesButton">
				<v-btn
					class="mt-3"
					color="primary"
					outlined
					@click="$emit('set:identified-breakages', identified_breakages)"
				>
					Сохранить
				</v-btn>
				<v-btn
					class="mt-3 ml-2"
					outlined
					@click="setIdentifiedBreakagesFromOrder"
				>
					Отмена
				</v-btn>
			</template>
			<v-divider class="my-3" />
			<h4 class="mb-2">Ущерб</h4>
			<v-alert
				type="warning"
				border="left"
				outlined
			>
				Блок в разработке
			</v-alert>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'RepairOrderShowDiagnostics',
	props: {
		order: {
			type: Object,
			required: true,
		},
	},
	data: () => ({
		breakage_cause: '',
		identified_breakages: '',
	}),
	computed: {
		showSaveBreakageCauseButton() {
			return this.breakage_cause !== this.order.breakage_cause;
		},
		showSaveIdentifiedBreakagesButton() {
			return this.identified_breakages !== this.order.identified_breakages;
		},
	},
	mounted() {
		this.setBreakageCauseFromOrder();
		this.setIdentifiedBreakagesFromOrder();
	},
	methods: {
		setBreakageCauseFromOrder() {
			this.breakage_cause = this.order.breakage_cause;
		},
		setIdentifiedBreakagesFromOrder() {
			this.identified_breakages = this.order.identified_breakages;
		},
	},
};
</script>

<style scoped>

</style>
